import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12db02cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oem-tip"
}
const _hoisted_2 = {
  key: 0,
  src: "https://static-jp.theckb.com/static-asset/client/activity/oem_tip.png",
  alt: "",
  class: "tip-img"
}
const _hoisted_3 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/oem_tip.png",
  alt: "",
  class: "tip-img"
}
const _hoisted_4 = { class: "oem-tip-content" }
const _hoisted_5 = {
  key: 0,
  class: "oem-tip-title"
}
const _hoisted_6 = { class: "oem-tip-time" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "close-content" }
const _hoisted_11 = { class: "text" }

import { ArrowDownBold } from '@element-plus/icons-vue'
import { useStore } from 'vuex'
import { computed, ref, onMounted } from 'vue'
import { isJA, isEN, useSite } from '@/store'
import { t } from '@/plugins/i18n'
import { tipList } from './data'

export default /*#__PURE__*/_defineComponent({
  props: ['name'],
  setup(__props) {

const props = __props
const store = useStore()


const show = ref(false)
const tip:any = ref([])

const getShow = (item: any) => {
  const localStatus = JSON.parse(localStorage.getItem(item.name) ?? '{}')
  const outTime = localStatus[store.getters?.user?.superCustomerId] ?? 0
  var now = new Date().setHours(0, 0, 0, 0)
  // 是否开始
  const isStart = (new Date(item.startTime).getTime() - new Date().getTime()) < 0
  // 是否到期
  const isOver = (new Date(item.endTime).getTime() - new Date().getTime()) < 0
  const haveLevel = store.getters.user?.membership?.templateLevel >= item.templateLevel
  const isStation = item.station.includes(useSite())
  return isStart && !isOver && (now > outTime) && isStation && haveLevel
}
const getList = () => {
  const arr = props.name.split(',')?.map((i: any) => tipList[i])
  return arr.filter((i: any) => getShow(i))
}
onMounted(() => {
  tip.value = getList()
  isOpen.value = tip.value.length === 1
})
const isOpen = ref(false)
const close = () => {
  const arr = props.name.split(',')
  arr.forEach((name:any) => {
    const localStatus = JSON.parse(localStorage.getItem(name) ?? '{}')
    localStatus[store.getters.user.superCustomerId] = new Date().getTime()
    localStorage.setItem(name, JSON.stringify(localStatus))
  })
  tip.value = getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (tip.value.length>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true),
        (!_unref(isJA)())
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tip.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "oem-tip-item"
            }, [
              (item.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tag, (temp, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "oem-tip-time-left",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(temp.title), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(temp.time), 1)
                  ]))
                }), 128))
              ]),
              (isOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (temp, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "oem-tip-warn",
                        style: {"margin-right":"10px"},
                        key: index
                      }, _toDisplayString(temp.text), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (tip.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["close-open", { open: isOpen.value }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(isOpen.value ? _unref(t)('收起') : _unref(t)('详细')), 1),
                _createVNode(_component_el_icon, { class: "icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowDownBold))
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "https://static-jp.theckb.com/static-asset/client/activity/close.png",
                alt: "",
                class: "close",
                onClick: close
              }))
            : _createCommentVNode("", true),
          (!_unref(isJA)())
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: "https://static-s.theckb.com/BusinessMarket/Client/activity/close.png",
                alt: "",
                class: "close",
                onClick: close
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})